<!--This is the template for MeSH.-->
<div *ngIf="getView() === 'notesQualifier'; else noIconTemplate">
    <div class="notesKey row">
        <div class="col-8"></div>
        <div class="col-4 icon-legend">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" 
                fill="currentColor" class="bi bi-stickies-fill" viewBox="0 0 14 14" 
                >
                <path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5"/>
                <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177z"/>
            </svg>
            <span style="padding-right: 10px;"> - {{'notes' | i18next}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"  
                fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 14 14"
                >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
            </svg>
            <span> - {{'qualifiers_label' | i18next}}</span>
        </div>
    </div>
</div>

<!--This is the template for Lexicon, Corporation, and Business Subject thesauri.-->
<ng-template #noIconTemplate>
    <div *ngIf="getView() === 'noIcon'; else notesOnlyTemplate">
        <div class="notesKey row">
            <div class="col-12"></div>
        </div>
    </div>
</ng-template>

<!--This is the default (for all other thesauri).-->
<ng-template #notesOnlyTemplate>
     <div class="notesKey row">
        <div class="col-8"></div>
        <div class="col-4 icon-legend">
            <svg xmlns="http://www.w3.org/2000/svg"
                width="14" height="14" fill="currentColor" 
                class="bi bi-stickies-fill" viewBox="0 0 14 14" 
                >
                <path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5"/>
                <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177z"/>
            </svg>
            <span> - {{'notes' | i18next}}</span>
        </div>
    </div>
</ng-template>